import {default as MobileLayout} from './MobileLayout-Component'
export default MobileLayout;